(() => {
  'use strict';
  if (window.cantripProductForms) return;
  window.cantripProductForms = true;
  const init = () => document.querySelectorAll('.custom-add-cart form:not(.set-event)').forEach(form => {
    form.classList.add('set-event');
    form.addEventListener('submit', async event => {
      const cart=document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if(!cart || typeof cart.getSectionsToRender !== 'function' || typeof fetchConfig !== 'function') return;
      event.preventDefault();
      const button=form.querySelector('button'); if(button.disabled)return;
      const config=fetchConfig('javascript');config.headers['X-Requested-With']='XMLHttpRequest';delete config.headers['Content-Type'];
      const data=new FormData(form);data.append('sections',cart.getSectionsToRender().map(section=>section.id));data.append('sections_url',window.location.pathname);config.body=data;
      button.disabled=true;button.setAttribute('aria-busy','true');
      let error=form.querySelector('[data-cart-error]');if(error)error.remove();
      try{
        const response=await fetch(routes.cart_add_url,config);const result=await response.json();
        if(!response.ok || result.status)throw Error(result.description || 'カートに追加できませんでした。');
        cart.renderContents(result);
      }catch(e){error=document.createElement('p');error.dataset.cartError='';error.setAttribute('role','alert');error.textContent=e.message || 'カートに追加できませんでした。';form.appendChild(error);}
      finally{button.disabled=false;button.removeAttribute('aria-busy');}
    });
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('cantrip:products-loaded',init);document.addEventListener('shopify:section:load',init);
})();
